/** COP32 reference dark dashboard (navy + cyan accent). */
export const COP32_DARK_SURFACE = {
    background: '#080d19',
    card: '#0c1829',
    popover: '#0c1829',
    foreground: '#e2e8f0',
    muted: '#111d2e',
    mutedForeground: '#64748b',
    border: '#1a2e44',
    input: '#1a2e44',
    ring: '#06b6d4',
    isDark: true,
};
